<div [formGroup]="chartOptionsForm" fxLayout="row" fxLayoutAlign="end start" fxLayout.lt-md="column"
  fxLayoutAlign.lt-md="space-between stretch" class="right-align-text">

  <lgd-date-picker controlName="beginDate" fxFlex="100" [fxFlex.md]="30" Label="Begin Date">
  </lgd-date-picker>

  <lgd-date-picker controlName="endDate" fxFlex="100" [fxFlex.md]="30" Label="End Date">
  </lgd-date-picker>

  <div fxFlex="100" [fxFlex.md]="30">
    <mat-button-toggle-group controlName="dateOption" [value]="selectedDateOption">
      @for (dateOption of dateOptions; track dateOption) {
        <mat-button-toggle [value]="dateOption" [ngClass]="getDateOptionClass(dateOption)"
          [attr.telemetry]="getDateOptionAriaLabel(dateOption)">
          {{dateOption}}
        </mat-button-toggle>
      }
    </mat-button-toggle-group>
  </div>
</div>